var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.41,
      fill: "#AFAFAF"
    },
    d: "M194.579,325.73c-4.067-0.017-8.139-0.18-12.215-0.514 c-44.672-3.662-96.423-24.993-118.666-63.831c-19.446-33.953-27.081-77.911-18.227-115.778 c8.323-35.595,34.127-64.429,70.26-75.378c40.636-12.313,85.548,2.648,125.534-14.168 c58.199-24.475,131.348-5.038,172.136,41.529c36.163,41.286,44.916,107.859,33.564,159.441 c-5.737,26.07-20.829,51.177-44.852,64.302c-19.114,10.443-42.219,12.502-64.076,9.78c-17.574-2.188-33.754-7.92-50.66-12.637 c-13.551-3.781-24.67-1.813-38.54,0.932C230.987,322.94,212.837,325.806,194.579,325.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9456,
      strokeMiterlimit: 10,
      strokeDasharray: "3.8511,3.8511"
    },
    d: " M204.551,300.82c-3.291-0.014-6.586-0.146-9.884-0.416c-36.148-2.963-78.023-20.224-96.021-51.65 c-15.735-27.474-21.914-63.044-14.749-93.685c6.735-28.803,27.615-52.135,56.853-60.994 c32.882-9.963,69.224,2.143,101.579-11.464c47.093-19.804,106.284-4.076,139.289,33.604 c29.262,33.408,36.345,87.277,27.159,129.016c-4.642,21.095-16.855,41.411-36.294,52.032 c-15.467,8.45-34.162,10.116-51.849,7.914c-14.221-1.771-27.313-6.408-40.993-10.226c-10.965-3.06-19.963-1.467-31.186,0.754 C234.012,298.563,219.325,300.881,204.551,300.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.87,
      fill: "#515159"
    },
    cx: 415.72,
    cy: 438.801,
    rx: 17.592,
    ry: 1.337
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFAFAF"
    },
    d: "M417.953,388.219c0,0-15.062-10.233-5.387-25.107c9.675-14.874,7.256-20.043,3.87-24.231 c8.223,9.357,6.421,20.018,1.517,26.781C413.049,372.424,412.272,381.627,417.953,388.219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEFEFE"
    },
    points: "430.242,400.916 401.198,400.916 404.033,437.685 427.407,437.685  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.128,
    y: 399.035,
    style: {
      fill: "#8B8B8C"
    },
    width: 35.184,
    height: 4.312
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M426.403,395.157h-21.365c-2.121,0-3.84,1.719-3.84,3.84v0.039h29.045v-0.039 C430.242,396.876,428.523,395.157,426.403,395.157z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDB62B"
    },
    points: "428.627,421.864 429.314,412.957 402.126,412.957 402.813,421.864  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFAFAF"
    },
    d: "M430.242,399.035v-0.039c0-2.121-1.719-3.84-3.84-3.84h-10.581c2.121,0,3.84,1.719,3.84,3.84 v0.039h3.069v4.312h-3.257l-2.647,34.337h10.581l2.648-34.337h3.257v-4.312H430.242z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M274.313,170.388c0,0,6.087-19.089-2.806-24.632c-5.653-2.905-8.742,0.714-8.742,0.714 s-2.658-13.497-20.975-9.038c-11.865,2.888-15.607-3.228-15.607-3.228s-0.111,16.919,8.06,21.95 c5.916,5.073,3.647,18.786,3.647,18.786L274.313,170.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.87,
      fill: "#515159"
    },
    d: "M328.274,419.842c0,0,32.977,0.991,42.18,9.486 c9.679,8.935,19.833,22.887-21.833,22.618c-41.666-0.269-78.603-11.737-113.549-8.097c-34.946,3.639-63.623,9.914-71.977,8.522 c-8.354-1.392,51.191-29.917,51.191-29.917l110.551,4.057L328.274,419.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87D1D"
    },
    d: "M297.43,345.666l-41.572-4.176l-41.572,4.176c0,0-2.469,19.643-10.497,30.122 c52.069,18.7,52.069,18.7,52.069,18.7s0,0,52.069-18.7C299.9,365.309,297.43,345.666,297.43,345.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87D1D"
    },
    d: "M254.216,393.898c1.64,0.589,1.642,0.59,1.642,0.59s0.002-0.001,1.64-0.589 c9.58-22.039,7.288-46.765,6.72-51.569l-8.359-0.84l-10.699,1.075C244.946,347.846,244.589,372,254.216,393.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#895436"
    },
    d: "M214.05,347.269c0.002,0.001,43.745,19.294,85.991,10.909c-1.898-6.858-2.61-12.512-2.61-12.512 l-41.572-4.176l-33.395,3.355L214.05,347.269L214.05,347.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515159"
    },
    d: "M234.242,156.153c5.916,5.073,3.647,18.786,3.647,18.786l7.739-0.967 c7.948-7.073,16.92-16.028,15.617-19.401c-2.283-5.912-8.877-11.813-21.036-12.488c-12.159-0.675-14.027-7.88-14.027-7.88 S226.071,151.122,234.242,156.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.349,204.055l-34.368,12.529l-5.695,129.083c0,0,12.149,5.695,41.572,5.695 c0-134.166,0-145.302,0-145.302L254.349,204.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.367,204.055l34.368,12.529l5.695,129.083c0,0-12.149,5.695-41.572,5.695 c0-134.166,0-145.302,0-145.302L257.367,204.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M219.981,216.584l-0.159,0.057c-10.039,3.585-18.061,11.301-22.034,21.193l-36.891,89.289 l31.37,3.738l26.556-65.085L219.981,216.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M291.735,216.584l0.16,0.057c10.039,3.585,18.061,11.301,22.034,21.193l36.891,89.289 l-31.37,3.738l-26.556-65.085L291.735,216.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M328.254,272.504l-14.325-34.671c-3.973-9.892-11.995-17.607-22.034-21.193l-0.16-0.057 l1.159,49.191l7.523,18.438C310.46,275.801,320.536,273.07,328.254,272.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M183.462,272.504l14.325-34.671c3.973-9.892,11.995-17.607,22.034-21.193l0.16-0.057 l-1.159,49.191l-7.523,18.438C201.256,275.801,191.18,273.07,183.462,272.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M293.981,267.475c0,0-0.931-1.304-2.245-3.747l1.159,2.046c0,0-13.076,72.576-48.031,85.299l0,0 c3.361,0.18,7.014,0.287,10.995,0.287c29.423,0,41.572-5.695,41.572-5.695L293.981,267.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "#FFF6E7"
    },
    d: "M203.789,257.966c8.865-24.867,9.358-24.677,28.721-29.233 c19.362-4.556,15.555-22.386,15.555-22.386l-18.052,6.58l-2.792,1.018l-7.24,2.639l-0.16,0.057 c-10.039,3.585-18.061,11.301-22.034,21.192l-35.362,85.589C177.359,312.429,196.238,279.145,203.789,257.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "#4C2A29"
    },
    d: "M307.927,257.966c-8.865-24.867-9.358-24.677-28.721-29.233 c-19.362-4.556-15.555-22.386-15.555-22.386l18.052,6.58l2.792,1.018l7.239,2.639l0.16,0.057 c10.039,3.585,18.061,11.301,22.034,21.192l35.362,85.589C334.357,312.429,315.478,279.145,307.927,257.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M255.951,219.98h-0.186c-5.08,0-9.199-4.118-9.199-9.199v-21.963h18.583v21.963 C265.15,215.862,261.031,219.98,255.951,219.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C2A29"
    },
    d: "M265.001,205.758c0.053,0,0.097-0.006,0.149-0.007v-16.933h-8.675l-9.909,3.581 C246.566,192.399,250.254,205.758,265.001,205.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C64F4F"
    },
    d: "M277.474,175.624c0,3.296-2.671,5.967-5.967,5.967c-3.295,0-5.967-2.671-5.967-5.967 c0-3.296,2.672-5.967,5.967-5.967C274.802,169.657,277.474,172.328,277.474,175.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#803D3D"
    },
    d: "M272.668,181.474c0.862-3.459,1.368-7.884,1.644-11.086c-0.84-0.451-1.786-0.731-2.806-0.731 c-3.295,0-5.967,2.672-5.967,5.967c0,3.296,2.672,5.967,5.967,5.967C271.905,181.591,272.292,181.548,272.668,181.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C64F4F"
    },
    d: "M234.242,175.624c0,3.296,2.672,5.967,5.967,5.967c3.296,0,5.967-2.671,5.967-5.967 c0-3.296-2.671-5.967-5.967-5.967C236.914,169.657,234.242,172.328,234.242,175.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#803D3D"
    },
    d: "M239.048,181.474c-0.863-3.459-1.368-7.884-1.644-11.086c0.84-0.451,1.786-0.731,2.806-0.731 c3.296,0,5.967,2.672,5.967,5.967c0,3.296-2.672,5.967-5.967,5.967C239.812,181.591,239.424,181.548,239.048,181.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M266.36,154.754h-10.502h-10.502l-5.198,11.357l0.874,11.24c0.467,5.998,4.342,16.355,9.794,18.9 c1.62,0.756,3.336,1.26,5.032,1.26c1.696,0,3.412-0.504,5.032-1.26c5.452-2.545,9.327-12.901,9.794-18.9l0.874-11.24 L266.36,154.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F2F35",
      strokeWidth: 1.3362,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M261.245,169.011 c0,0,3.524,0.988,7.511,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F2F35",
      strokeWidth: 2.6723,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M260.107,162.552 c0,0,5.147-0.856,8.241,0.927"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F2F35",
      strokeWidth: 1.3362,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M250.471,169.011 c0,0-3.524,0.988-7.512,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F2F35",
      strokeWidth: 2.6723,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M251.609,162.552 c0,0-5.147-0.856-8.241,0.927"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "#FFF6E7"
    },
    d: "M247.489,178.805c-0.686-11.357-2.133-24.051-2.133-24.051l-5.198,11.357 l0.278,3.568c-0.077-0.003-0.149-0.023-0.226-0.023c-3.295,0-5.967,2.672-5.967,5.967c0,3.296,2.672,5.967,5.967,5.967 c0.522,0,1.02-0.088,1.502-0.214c1.405,5.805,4.753,12.839,9.115,14.875c1.62,0.756,3.336,1.26,5.032,1.26 C255.858,197.512,248.175,190.163,247.489,178.805z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C4242"
    },
    d: "M291.735,396.16l-118.768-36.034c-15.77-4.785-32.355,4.499-36.523,20.442l-0.157,0.602 c-4.294,16.427,6.358,33.022,23.083,35.945c43.913,7.676,123.506,20.73,165.396,22.326l17.658,11.772 c2.666,1.778,6.206,1.485,8.544-0.707l0.091-0.085c2.778-2.604,2.92-6.967,0.317-9.747l-2.754-2.941 c0,0-2.455-11.959-14.579-17.085c-12.124-5.125-13.263-17.654-16.11-24.488C315.084,389.326,296.861,385.91,291.735,396.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M136.444,380.568c4.168-15.944,20.754-25.227,36.523-20.442l40.277,12.22 c-6.067,7.569-14.069,22.933-14.311,51.447c-14.705-2.39-28.31-4.711-39.564-6.678c-16.725-2.923-27.377-19.519-23.083-35.945 L136.444,380.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#A87D1D"
    },
    d: "M173.91,405.618c0,4.843-1.162,9.413-3.21,13.457 c-3.977-0.682-7.782-1.34-11.33-1.96c-16.725-2.923-27.377-19.519-23.083-35.945l0.157-0.602 c0.374-1.432,0.852-2.808,1.417-4.127c2.006-0.426,4.085-0.654,6.218-0.654C160.554,375.788,173.91,389.143,173.91,405.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B3C38",
      strokeWidth: 1.139,
      strokeMiterlimit: 10
    },
    d: "M297.43,412.675 c0,0-1.708,9.953-18.223,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "#4C2A29"
    },
    d: "M307.927,408.119c0,0-25.304-1.139-78.835-10.688 c-43.369-7.736-56.091-29.935-59.359-38.085c1.079,0.198,2.158,0.453,3.233,0.779l118.768,36.034 c5.126-10.251,23.349-6.834,26.196,0c2.847,6.834,3.986,19.362,16.11,24.488c12.124,5.125,14.579,17.085,14.579,17.085 s-12.466-7.973-20.347-9.681S307.927,408.119,307.927,408.119z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M313.407,438.801c0,0,21.809,20.867,40.402,12.28c3.094-1.428,4.063-5.379,2.043-8.122 c-15.662-21.271-35.409-44.444-42.936-53.153c-1.884-2.18-4.867-3.061-7.634-2.257l-21.419,6.222L313.407,438.801z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5A5A5"
    },
    points: "283.863,393.772 263.348,387.547 278.888,435.368 313.407,438.801  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M219.981,396.16l118.769-36.034c15.77-4.785,32.355,4.499,36.523,20.442l0.157,0.602 c4.294,16.427-6.358,33.022-23.083,35.945c-43.913,7.676-123.506,20.73-165.396,22.326l-17.658,11.772 c-2.666,1.778-6.206,1.485-8.544-0.707l-0.091-0.085c-2.778-2.604-2.92-6.967-0.317-9.747l2.754-2.941 c0,0,2.455-11.959,14.579-17.085c12.124-5.125,13.263-17.654,16.11-24.488C196.632,389.326,214.855,385.91,219.981,396.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M375.272,380.568c-4.168-15.944-20.754-25.227-36.523-20.442l-40.277,12.22 c6.067,7.569,14.069,22.933,14.31,51.447c14.705-2.39,28.31-4.711,39.564-6.678c16.725-2.923,27.377-19.519,23.083-35.945 L375.272,380.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#A87D1D"
    },
    d: "M337.806,405.618c0,4.843,1.162,9.413,3.21,13.457 c3.977-0.682,7.782-1.34,11.33-1.96c16.725-2.923,27.377-19.519,23.083-35.945l-0.157-0.602 c-0.374-1.432-0.852-2.808-1.417-4.127c-2.006-0.426-4.085-0.654-6.218-0.654C351.162,375.788,337.806,389.143,337.806,405.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "#4C2A29"
    },
    d: "M203.789,408.119c0,0,25.304-1.139,78.835-10.688 c43.369-7.736,56.091-29.935,59.359-38.085c-1.079,0.198-2.158,0.453-3.233,0.779L219.981,396.16 c-5.125-10.251-23.349-6.834-26.196,0c-2.847,6.834-3.986,19.362-16.11,24.488c-12.124,5.125-14.579,17.085-14.579,17.085 s12.466-7.973,20.347-9.681C191.323,426.343,203.789,408.119,203.789,408.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.1139,
      strokeMiterlimit: 10
    },
    d: "M177.674,420.648 l-17.804-3.301c-16.114-2.572-27.027-17.805-24.278-33.89l0.108-0.63c2.997-17.537,20.797-28.384,37.757-23.008l33.617,10.655"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.752,178.619c-0.64,0-1.016,0.742-0.623,1.247c1.783,2.289,4.143,3.688,6.738,3.688 c2.595,0,4.955-1.399,6.738-3.688c0.393-0.505,0.017-1.247-0.623-1.247H249.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2F2F35",
      strokeWidth: 0.8212,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M257.621,168.76 v6.178c0,0-1.421-0.803-3.398,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.245,
    y: 146.469,
    style: {
      fill: "#FF7E6E"
    },
    width: 1.52,
    height: 9.666
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M350.82,327.122l0.063,0.174c3.56,9.856-0.704,20.827-9.986,25.693l-63.423,33.246l-0.313-0.81 c-5.588-14.435,0.257-30.785,13.729-38.407l28.561-16.158L350.82,327.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "#4C2A29"
    },
    d: "M337.428,347.486c0,2.341,0.585,4.543,1.607,6.478l1.862-0.976 c7.32-3.837,11.5-11.474,11.201-19.364c-0.256-0.014-0.509-0.039-0.769-0.039C343.651,333.585,337.428,339.809,337.428,347.486z "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#4C2A29",
      strokeWidth: 1.3362,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 319.45,
    y1: 330.86,
    x2: 337.428,
    y2: 320.665
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7E6E"
    },
    d: "M161.082,327.122l-0.063,0.174c-3.56,9.856,0.704,20.827,9.986,25.693l63.423,33.246l0.314-0.81 c5.588-14.435-0.257-30.785-13.729-38.407l-28.561-16.158L161.082,327.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "#4C2A29"
    },
    d: "M174.474,347.486c0,2.341-0.585,4.543-1.607,6.478l-1.862-0.976 c-7.32-3.837-11.499-11.474-11.201-19.364c0.256-0.014,0.509-0.039,0.769-0.039C168.25,333.585,174.474,339.809,174.474,347.486 z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#4C2A29",
      strokeWidth: 1.3362,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 192.452,
    y1: 330.86,
    x2: 174.474,
    y2: 320.665
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#4C2A29",
      strokeWidth: 1.3362,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M227.39,382.545 c0,0,3.201-17.564-7.223-23.199"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#4C2A29",
      strokeWidth: 1.3362,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M284.326,382.545 c0,0-3.201-17.564,7.223-23.199"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M198.309,438.801c0,0-21.809,20.867-40.402,12.28c-3.093-1.428-4.063-5.379-2.043-8.122 c15.662-21.271,35.408-44.444,42.936-53.153c1.884-2.18,4.867-3.061,7.634-2.257l21.419,6.222L198.309,438.801z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECECEC"
    },
    points: "227.854,393.772 248.368,387.547 232.828,435.368 198.309,438.801  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "#4C2A29"
    },
    d: "M219.322,406.775c6.085-0.649,13.989-1.6,23.766-2.98l5.28-16.247l-20.514,6.224 L219.322,406.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF6E7"
    },
    d: "M204.845,424.278l-11.901,18.138c-0.741,1.129-2.065,1.733-3.404,1.551l-0.079-0.011 c-2.578-0.35-3.89-3.287-2.431-5.441l12.172-17.969c0.779-1.15,2.186-1.699,3.537-1.382l0.07,0.016 C205.075,419.712,206.121,422.333,204.845,424.278z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFAFAF"
    },
    points: "254.223,319.447 181.391,319.447 199.348,383.408 254.223,383.408 309.098,383.408  327.055,319.447  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.348,
    y: 383.408,
    style: {
      fill: "#8B8B8C"
    },
    width: 109.75,
    height: 9.316
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#5A5A63"
    },
    cx: 254.348,
    cy: 356.468,
    rx: 17.808,
    ry: 9.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.391,
    y: 315.204,
    style: {
      fill: "#5A5A63"
    },
    width: 145.664,
    height: 4.243
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.427,
    y: 386.083,
    style: {
      fill: "#5A5A63"
    },
    width: 10.991,
    height: 3.745
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.29,
    y: 386.083,
    style: {
      fill: "#5A5A63"
    },
    width: 10.991,
    height: 3.745
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#0F1201",
      strokeMiterlimit: 10
    },
    x1: 309.098,
    y1: 388.066,
    x2: 242.304,
    y2: 388.066
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#FFFFFF"
    },
    d: "M181.391,319.447l17.957,63.962h39.089c23.21-26.91,37.312-63.962,37.312-63.962 l-0.048-4.243h-94.31V319.447z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      opacity: 0.57,
      fill: "none",
      stroke: "#0F1201",
      strokeMiterlimit: 10
    },
    x1: 181.391,
    y1: 319.447,
    x2: 327.055,
    y2: 319.447
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.87,
      fill: "#515159"
    },
    cx: 105.722,
    cy: 438.801,
    rx: 26.412,
    ry: 1.337
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M109.584,425.649l1.731-1.886l-0.865,0.943l0.873-0.936 c-0.213-0.203-21.057-21.335,4.121-116.56l-2.476-0.655C87.263,403.773,108.661,424.801,109.584,425.649z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M101.819,308.849c9.536,8.666,7.865,18.912,7.865,18.912s-9.55-4.073-11.765-16.766 C97.53,308.769,100.147,307.329,101.819,308.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M125.678,314.966c-12.53,3.008-15.995,12.795-15.995,12.795s10.331,1.025,18.382-9.037 C129.477,316.96,127.875,314.439,125.678,314.966z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M95.285,333.753c10.359,7.664,9.726,18.026,9.726,18.026S95.1,348.687,91.62,336.28 C91.01,334.104,93.468,332.409,95.285,333.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M119.639,337.441c-12.164,4.252-14.628,14.337-14.628,14.337s10.382-0.019,17.38-10.838 C123.618,339.044,121.771,336.696,119.639,337.441z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M91.144,355.592c10.898,6.876,11.033,17.257,11.033,17.257s-10.112-2.35-14.501-14.466 C86.907,356.259,89.234,354.386,91.144,355.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M115.704,357.469c-11.816,5.141-13.527,15.38-13.527,15.38s10.352-0.787,16.531-12.095 C119.791,358.772,117.776,356.567,115.704,357.469z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M122.247,289.768c0.216,12.884-8.395,18.683-8.395,18.683s-3.572-9.748,4.16-20.056 C119.367,286.588,122.209,287.509,122.247,289.768z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.875,
    y: 383.429,
    style: {
      fill: "#EDB62B"
    },
    width: 27.689,
    height: 54.776
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.502,
    y: 383.429,
    style: {
      opacity: 0.67,
      fill: "#A87D1D"
    },
    width: 11.062,
    height: 54.776
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87D1D"
    },
    d: "M130.723,122.176l-9.963,2.478c-1.445,0.36-2.909-0.521-3.268-1.966l-0.959-3.856l15.198-3.78 l0.959,3.856C133.049,120.354,132.169,121.817,130.723,122.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87D1D"
    },
    d: "M167.745,110.295L81.677,131.7c-1.493,0.371-3.005-0.538-3.377-2.032L64.106,72.594 c-0.371-1.493,0.538-3.005,2.032-3.377l86.068-21.405c1.493-0.371,3.005,0.538,3.376,2.032l14.194,57.074 C170.148,108.412,169.238,109.923,167.745,110.295z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDB62B"
    },
    points: "165.194,100.431 162.794,107.327 86.431,126.318 79.65,121.706 65.585,65.156  151.13,43.881  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.983,
    y: 59.112,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -18.536 25.1642)",
    style: {
      fill: "#FFFFFF"
    },
    width: 42.946,
    height: 58.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.168,
    y: 63.858,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -13.0622 23.1109)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.742,
    y: 70.186,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -14.5429 23.678)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.315,
    y: 76.513,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -16.0233 24.2446)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.889,
    y: 82.84,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -17.5039 24.8114)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.462,
    y: 89.168,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -18.9847 25.3785)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.036,
    y: 95.495,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -20.4651 25.9451)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.61,
    y: 101.822,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -21.9456 26.5119)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.183,
    y: 108.15,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -23.4265 27.0792)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.85,
    y: 48.202,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -14.6061 35.4294)",
    style: {
      fill: "#FFFFFF"
    },
    width: 42.946,
    height: 58.273
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.72,
    y: 53.027,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -9.1606 33.3023)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.294,
    y: 59.354,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -10.6411 33.8688)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.867,
    y: 65.682,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -12.1217 34.4356)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.441,
    y: 72.009,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -13.6024 35.0029)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.015,
    y: 78.336,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -15.0829 35.5694)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.588,
    y: 84.664,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -16.5634 36.1361)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.162,
    y: 90.991,
    transform: "matrix(0.9704 -0.2414 0.2414 0.9704 -18.0442 36.7034)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.735,
    y: 97.318,
    transform: "matrix(0.9704 -0.2413 0.2413 0.9704 -19.5246 37.2698)",
    style: {
      fill: "#AFAFAF"
    },
    width: 35.286,
    height: 2.038
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M128.113,118.871l-6.594,1.64c-1.445,0.359-2.907-0.521-3.267-1.965l-0.602-2.421l11.826-2.941 l0.602,2.421C130.437,117.049,129.557,118.512,128.113,118.871z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M274.466,37.557c-3.42-3.252-7.741-5.47-12.19-6.952c-0.03-0.01-0.098-0.029-0.2-0.056 c-4.03-1.079-8.278-1.079-12.308,0c-0.101,0.027-0.17,0.046-0.2,0.056c-4.449,1.482-8.77,3.701-12.19,6.952 c-10.18,9.679-8.526,27.247,1.388,36.517c2.781,2.6,4.002,5.957,4.853,9.658c0.257,1.115,1.732,12.74,1.217,12.74 c4.975,0,11.085,0,11.085,0s6.11,0,11.085,0c-0.514,0,0.961-11.626,1.217-12.74c0.852-3.7,2.073-7.057,4.854-9.658 C282.992,64.805,284.645,47.237,274.466,37.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "#FFF6E7"
    },
    d: "M251.935,83.732c-0.851-3.7-2.073-7.057-4.853-9.658 c-9.914-9.27-11.568-26.838-1.388-36.517c3.42-3.252,7.741-5.47,12.19-6.952c0.03-0.01,0.098-0.029,0.2-0.056 c0.66-0.177,1.326-0.314,1.996-0.433c-3.42-0.607-6.942-0.47-10.312,0.433c-0.101,0.027-0.17,0.046-0.2,0.056 c-4.449,1.482-8.771,3.701-12.19,6.952c-10.18,9.679-8.526,27.247,1.388,36.517c2.781,2.6,4.002,5.957,4.853,9.658 c0.257,1.115,1.732,12.74,1.217,12.74c2.857,0,6.082,0,8.316,0C253.667,96.472,252.192,84.846,251.935,83.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FEFEFE",
      strokeWidth: 2.2387,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M255.922,96.472 V69.36l4.772-2.751c1.577-0.909,1.262-3.272-0.498-3.736l-8.684-2.292c-1.481-0.391-1.649-2.425-0.252-3.054l4.661-2.097v-9.203 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M269.213,100.203c0,0.824-0.668,1.492-1.492,1.492h-24.376c-0.824,0-1.492-0.668-1.492-1.492l0,0 c0-0.824,0.668-1.492,1.492-1.492h24.376C268.544,98.711,269.213,99.379,269.213,100.203L269.213,100.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M269.213,104.68c0,0.824-0.668,1.493-1.492,1.493h-24.376c-0.824,0-1.492-0.668-1.492-1.493l0,0 c0-0.824,0.668-1.492,1.492-1.492h24.376C268.544,103.188,269.213,103.856,269.213,104.68L269.213,104.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M269.213,109.157c0,0.824-0.668,1.492-1.492,1.492h-24.376c-0.824,0-1.492-0.668-1.492-1.492l0,0 c0-0.824,0.668-1.493,1.492-1.493h24.376C268.544,107.665,269.213,108.333,269.213,109.157L269.213,109.157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M255.532,121.096c4.808,0,8.706-3.898,8.706-8.706h-17.411 C246.827,117.199,250.724,121.096,255.532,121.096z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M358.665,126.82v-7.009h-3.097c-0.586-3.329-1.947-6.383-3.891-8.984l2.457-2.457l-4.956-4.956 l-2.549,2.549c-2.609-1.782-5.642-2.976-8.909-3.447v-3.661h-7.008v3.798c-3.133,0.591-6.013,1.873-8.497,3.676l-2.481-2.481 l-4.956,4.956l2.513,2.513c-1.836,2.611-3.086,5.653-3.593,8.945h-3.479v7.008h3.556c0.574,3.212,1.868,6.166,3.712,8.704 l-2.738,2.738l4.956,4.956l2.773-2.772c2.542,1.786,5.493,3.017,8.686,3.549v3.783h7.008v-3.783 c3.182-0.529,6.123-1.753,8.66-3.529l2.318,2.318l4.956-4.956L351.828,136c1.94-2.661,3.268-5.785,3.801-9.18H358.665z  M334.668,135.436c-6.584,0-11.922-5.338-11.922-11.922c0-6.585,5.338-11.922,11.922-11.922c6.585,0,11.922,5.338,11.922,11.922 C346.59,130.099,341.253,135.436,334.668,135.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E9E9E"
    },
    d: "M386.613,153.402v-4.043h-1.787c-0.338-1.921-1.123-3.682-2.244-5.183l1.418-1.418l-2.859-2.859 l-1.47,1.47c-1.505-1.028-3.255-1.717-5.14-1.989v-2.112h-4.043v2.191c-1.807,0.341-3.469,1.081-4.902,2.121l-1.431-1.431 l-2.859,2.859l1.45,1.45c-1.059,1.506-1.78,3.261-2.073,5.16h-2.007v4.043h2.052c0.331,1.853,1.078,3.557,2.141,5.021 l-1.58,1.58l2.859,2.859l1.599-1.599c1.467,1.031,3.169,1.741,5.01,2.047v2.182h4.043v-2.182 c1.836-0.305,3.533-1.011,4.996-2.036l1.337,1.337l2.859-2.859l-1.314-1.314c1.119-1.535,1.886-3.337,2.192-5.296H386.613z  M372.769,158.372c-3.798,0-6.878-3.079-6.878-6.878c0-3.798,3.079-6.878,6.878-6.878s6.878,3.079,6.878,6.878 C379.647,155.293,376.568,158.372,372.769,158.372z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B8B8C"
    },
    d: "M450.313,101.039V86.646h-6.361c-1.204-6.837-3.998-13.108-7.99-18.451l5.047-5.047 l-10.177-10.177l-5.234,5.234c-5.358-3.659-11.586-6.111-18.296-7.08v-7.518h-14.393v7.8c-6.433,1.213-12.349,3.847-17.45,7.55 l-5.094-5.094l-10.177,10.177l5.161,5.161c-3.771,5.362-6.337,11.609-7.378,18.37h-7.146v14.393h7.304 c1.179,6.596,3.837,12.662,7.623,17.874l-5.624,5.624l10.177,10.177l5.694-5.693c5.221,3.669,11.28,6.197,17.837,7.288v7.769 h14.393v-7.769c6.534-1.087,12.575-3.6,17.784-7.248l4.761,4.761l10.177-10.177l-4.677-4.677 c3.984-5.465,6.712-11.879,7.805-18.853H450.313z M401.032,118.735c-13.522,0-24.484-10.962-24.484-24.483 c0-13.522,10.962-24.484,24.484-24.484c13.522,0,24.484,10.962,24.484,24.484C425.516,107.773,414.554,118.735,401.032,118.735 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    cx: 400.569,
    cy: 94.306,
    r: 14.367
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A63"
    },
    d: "M120.715,167.801c-30.87,1.872-54.866,20.372-53.595,41.32 c1.271,20.948,27.326,36.412,58.196,34.539c0.023-0.001,0.046-0.003,0.069-0.004c3.038-0.187,5.163-3.122,4.412-6.071 c-0.365-1.435-0.571-2.938-0.595-4.49c-0.157-9.985,7.567-18.564,17.513-19.463c7.218-0.652,13.812,2.741,17.618,8.263 c1.878,2.725,5.87,2.918,7.901,0.304c4.641-5.974,7.107-12.775,6.677-19.858C177.641,181.392,151.586,165.928,120.715,167.801z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B8B8C"
    },
    d: "M120.51,164.411c-30.87,1.872-54.866,20.372-53.595,41.32 c1.271,20.948,27.326,36.412,58.197,34.539c0.023-0.001,0.046-0.003,0.069-0.004c3.038-0.187,5.163-3.122,4.412-6.071 c-0.365-1.435-0.571-2.938-0.595-4.49c-0.157-9.985,7.567-18.564,17.513-19.463c7.218-0.652,13.812,2.741,17.618,8.263 c1.878,2.725,5.87,2.918,7.901,0.304c4.641-5.974,7.107-12.775,6.677-19.858C177.435,178.002,151.38,162.538,120.51,164.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M109.607,223.795c0.226,3.721-2.608,6.921-6.329,7.147c-3.721,0.226-6.921-2.608-7.147-6.329 c-0.226-3.721,2.608-6.921,6.329-7.147C106.181,217.24,109.381,220.074,109.607,223.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M91.217,211.019c0.226,3.721-2.608,6.921-6.329,7.147c-3.721,0.226-6.921-2.608-7.147-6.329 s2.608-6.921,6.329-7.147C87.792,204.464,90.991,207.298,91.217,211.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M96.624,188.673c0.226,3.721-2.608,6.921-6.329,7.147c-3.721,0.226-6.921-2.608-7.147-6.329 s2.608-6.921,6.329-7.147C93.199,182.118,96.399,184.952,96.624,188.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M119.415,176.596c0.226,3.721-2.608,6.921-6.329,7.147c-3.721,0.226-6.921-2.608-7.147-6.329 c-0.226-3.721,2.608-6.921,6.329-7.147C115.989,170.041,119.189,172.875,119.415,176.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M145.086,176.926c0.226,3.721-2.608,6.921-6.329,7.147s-6.921-2.608-7.147-6.329 c-0.226-3.721,2.608-6.921,6.329-7.147C141.66,170.371,144.86,173.205,145.086,176.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M166.753,189.137c0.226,3.721-2.608,6.921-6.329,7.147c-3.721,0.226-6.921-2.608-7.147-6.329 c-0.226-3.721,2.608-6.921,6.329-7.147C163.328,182.582,166.528,185.416,166.753,189.137z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#2F2F35"
    },
    d: "M150.554,168.409l-6.355,13.296c-0.838-0.041-1.648,0.435-1.982,1.257l-0.018,0.045 c-0.424,1.04,0.076,2.227,1.117,2.651l0.596,0.243c-0.117-0.039-0.723-0.11-2.001,1.751v0c-0.001,0.001-0.001,0.001-0.001,0.002 c-0.077,0.112-0.157,0.233-0.239,0.36c-0.008,0.013-0.016,0.025-0.025,0.038c-0.076,0.119-0.155,0.245-0.236,0.377 c-0.016,0.027-0.032,0.053-0.049,0.08c-0.076,0.125-0.153,0.256-0.232,0.393c-0.023,0.04-0.047,0.081-0.071,0.123 c-0.075,0.131-0.151,0.267-0.229,0.409c-0.031,0.056-0.062,0.114-0.094,0.172c-0.074,0.137-0.15,0.279-0.227,0.426 c-0.038,0.072-0.076,0.146-0.115,0.221c-0.074,0.143-0.149,0.289-0.226,0.442c-0.045,0.09-0.091,0.183-0.138,0.277 c-0.074,0.149-0.148,0.3-0.223,0.457c-0.052,0.108-0.105,0.22-0.159,0.333c-0.074,0.157-0.149,0.315-0.225,0.48 c-0.058,0.124-0.117,0.255-0.176,0.384c-0.075,0.165-0.15,0.33-0.227,0.503c-0.065,0.146-0.132,0.3-0.199,0.453 c-0.074,0.169-0.148,0.337-0.224,0.513c-0.073,0.17-0.148,0.348-0.223,0.525c-0.074,0.176-0.148,0.349-0.224,0.532 c-0.08,0.192-0.162,0.394-0.244,0.593c-0.074,0.181-0.147,0.358-0.223,0.546c-0.088,0.219-0.18,0.451-0.27,0.68 c-0.073,0.185-0.145,0.365-0.22,0.557c-0.101,0.258-0.205,0.53-0.309,0.8c-0.067,0.175-0.133,0.343-0.201,0.523 c-0.123,0.324-0.249,0.664-0.376,1.003c-0.053,0.143-0.105,0.279-0.159,0.425c-0.182,0.494-0.368,1.003-0.558,1.532 c-0.509,1.417-1.104,3.085-1.76,4.935c-0.076,0.215-0.15,0.424-0.229,0.644c-0.099,0.28-0.203,0.573-0.305,0.862 c-0.085,0.24-0.168,0.475-0.255,0.721c-0.134,0.379-0.272,0.771-0.41,1.163c-0.062,0.176-0.122,0.347-0.185,0.525 c-0.137,0.388-0.277,0.786-0.417,1.185c-0.071,0.203-0.142,0.402-0.214,0.608c-0.132,0.374-0.266,0.758-0.401,1.141 c-0.083,0.237-0.165,0.469-0.249,0.709c-0.155,0.443-0.313,0.894-0.472,1.347c-0.06,0.17-0.118,0.337-0.178,0.509 c-0.161,0.462-0.325,0.931-0.49,1.402c-0.07,0.201-0.14,0.4-0.21,0.602c-0.153,0.438-0.308,0.883-0.463,1.328 c-0.079,0.227-0.157,0.451-0.237,0.68c-0.165,0.472-0.331,0.95-0.497,1.429c-0.072,0.206-0.143,0.41-0.214,0.617 c-0.164,0.471-0.329,0.947-0.494,1.424c-0.083,0.238-0.165,0.474-0.247,0.713c-0.148,0.428-0.297,0.858-0.446,1.289 c-0.106,0.305-0.211,0.61-0.317,0.917c-0.128,0.37-0.257,0.743-0.385,1.115c-0.122,0.354-0.244,0.707-0.367,1.062 c-0.137,0.398-0.275,0.797-0.412,1.196c-0.072,0.209-0.144,0.416-0.216,0.626l0,0h0c-1.121,3.257-2.251,6.562-3.363,9.836 c0.98-0.025,1.966-0.066,2.957-0.126c0.023-0.001,0.046-0.003,0.069-0.004c3.038-0.187,5.163-3.122,4.412-6.071 c-0.365-1.435-0.571-2.938-0.595-4.49c-0.137-8.739,5.761-16.4,13.903-18.78c0.9-1.948,1.704-3.696,2.377-5.171 c7.162-15.684,5.382-17.09,5.157-17.199l0.596,0.243c1.04,0.423,2.227-0.077,2.651-1.117l0.018-0.045 c0.396-0.973-0.022-2.066-0.929-2.551l4.762-13.69C155.332,170.281,153.001,169.282,150.554,168.409z M143.934,185.909 L143.934,185.909l0.167,0.068L143.934,185.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#FFFFFF"
    },
    d: "M95.456,187.64c0.094,1.556-1.091,2.895-2.647,2.989 c-1.556,0.094-2.895-1.091-2.989-2.647c-0.094-1.556,1.091-2.895,2.647-2.989C94.023,184.899,95.361,186.084,95.456,187.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#FFFFFF"
    },
    d: "M118.261,175.805c0.094,1.556-1.091,2.895-2.647,2.989 c-1.556,0.094-2.895-1.091-2.989-2.647c-0.094-1.556,1.091-2.895,2.647-2.989C116.828,173.063,118.166,174.248,118.261,175.805z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#FFFFFF"
    },
    d: "M142.408,175.201c0.094,1.556-1.091,2.895-2.647,2.989 c-1.556,0.094-2.895-1.091-2.989-2.647c-0.094-1.556,1.091-2.895,2.647-2.989C140.975,172.46,142.313,173.645,142.408,175.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#FFFFFF"
    },
    d: "M88.371,209.027c0.094,1.556-1.091,2.895-2.647,2.989 c-1.556,0.094-2.895-1.091-2.989-2.647s1.091-2.895,2.647-2.989C86.938,206.286,88.276,207.471,88.371,209.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#FFFFFF"
    },
    d: "M108.382,221.836c0.094,1.556-1.091,2.895-2.647,2.989 c-1.556,0.094-2.895-1.091-2.989-2.647c-0.094-1.556,1.091-2.895,2.647-2.989C106.949,219.095,108.287,220.28,108.382,221.836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB62B"
    },
    d: "M175.236,164.393c0,0,9.21-5.034,9.8-12.814c-0.037-4.598-2.034-8.371-2.034-8.371l-1.261,4.738 c0,0-0.693-7.443-6.008-11.039c-5.315-3.596-4.007-2.586-4.007-2.586s4.463,5.923-0.491,15.745 c-4.954,9.822,1.298,13.227,1.298,13.227L175.236,164.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87D1D"
    },
    d: "M174.667,161.204c0,0-1.666-8.542,2.141-13.132c-4.949,6.274-5.971,11.315-4.728,15.388 C174.667,161.204,174.667,161.204,174.667,161.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.218,162.892c0.811-1.642,2.752-2.379,4.449-1.688l0.03,0.012l0.03,0.012 c1.696,0.691,2.571,2.574,2.004,4.316l-6.056,18.605l-4.56-1.857l-4.56-1.857L170.218,162.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M160.85,184.594l7.715,3.141c1.04,0.424,2.227-0.076,2.651-1.117l0.018-0.045 c0.424-1.041-0.076-2.227-1.117-2.651l-7.715-3.141c-1.04-0.424-2.227,0.076-2.651,1.117l-0.018,0.045 C159.31,182.983,159.81,184.17,160.85,184.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F2F35"
    },
    d: "M161.469,184.845l3.239,1.318l3.239,1.319c0,0,2.458,0.581-5.135,17.208 c-5.643,12.358-20.158,43.352-28.522,59.912c-0.782,1.549-3.128,0.594-2.606-1.061c5.582-17.693,16.845-50.011,21.439-62.796 C159.304,183.544,161.469,184.845,161.469,184.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M144.194,244.359c-3.615,7.538-7.105,14.701-9.905,20.244c-0.782,1.549-3.128,0.594-2.606-1.061 c1.869-5.923,4.375-13.486,7.053-21.406L144.194,244.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "#FFFFFF"
    },
    d: "M143.052,229.496L143.052,229.496c11.9-14.729,16.374-42.786,16.394-42.908 c-1.321,1.924-3.359,5.912-6.323,14.159C150.878,206.994,147.041,217.906,143.052,229.496z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E9E9E"
    },
    points: "373.444,194.954 375.552,199.226 380.266,199.911 376.855,203.236 377.66,207.932  373.444,205.715 369.227,207.932 370.033,203.236 366.622,199.911 371.336,199.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#666666"
    },
    points: "434.141,188.986 437.085,194.951 443.668,195.908 438.905,200.551 440.029,207.107  434.141,204.012 428.254,207.107 429.378,200.551 424.615,195.908 431.198,194.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E9E9E"
    },
    points: "415.72,278.379 417.363,281.708 421.038,282.242 418.379,284.834 419.007,288.493  415.72,286.765 412.434,288.493 413.061,284.834 410.402,282.242 414.077,281.708  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#666666"
    },
    points: "357.095,255.824 360.039,261.789 366.621,262.745 361.858,267.388 362.983,273.944  357.095,270.849 351.207,273.944 352.332,267.388 347.568,262.745 354.151,261.789  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9282 -0.3722 0.3722 0.9282 -60.2869 166.5638)",
    style: {
      fill: "#EDB62B"
    },
    cx: 401.305,
    cy: 239.442,
    rx: 32.829,
    ry: 32.829
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.67
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A87D1D"
    },
    d: "M392.481,271.063c11.597,3.236,23.472-0.183,31.573-7.955 c-5.486,1.47-11.424,1.542-17.291-0.095c-17.464-4.873-27.671-22.98-22.798-40.444c1.637-5.867,4.773-10.91,8.871-14.842 c-10.843,2.906-19.917,11.296-23.153,22.893C364.811,248.083,375.018,266.19,392.481,271.063z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "#FFF6E7"
    },
    d: "M410.128,207.822c-1.635-0.456-3.277-0.78-4.912-0.979 c-0.856,3.07-1.323,6.301-1.323,9.644c0,17.089,11.964,31.374,27.97,34.962c0.404-1.032,0.76-2.093,1.064-3.183 C437.798,230.802,427.591,212.694,410.128,207.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#666666",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M368.589,236.741 c-12.736-4.962-20.658-9.451-19.992-11.836c1.107-3.968,25.555-0.613,54.606,7.493c29.051,8.106,51.703,17.894,50.596,21.862 c-0.663,2.378-9.707,2.126-23.101-0.202"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.1bb2f24d82d79c2ef52fab975e490e04.svg";
export { ForwardRef as ReactComponent };